import React, { Component } from 'react'
import { FormattedMessage } from 'react-intl'

class CreditMemoStatusBadge extends Component {

    constructor(props, context) {
        super(props, context);
        this.state = {
            status: this.props.status || '',
            style: this.props.style || {},
        }
        this.className = this.props.className || ''
    }
    componentWillReceiveProps(nextProps, nextContext) {
        this.setState({
            status: nextProps.status || '',
            style: nextProps.style || {},
        })
    }

    renderStatus() {
        switch (this.state.status) {
            case 'available':
                return <div className="badge badge-primary text-with-icon">
                    <FormattedMessage
                        id="credit_memo.status.available_label"
                        defaultMessage="Available"
                    />
                </div>
            case 'partially-applied':
                return <div className="badge badge-warning text-with-icon">
                    <FormattedMessage
                        id="credit_memo.status.partially_applied_label"
                        defaultMessage="Partially applied"
                    />
                </div>
            case 'fully-applied':
                return <div className="badge badge-success text-with-icon">
                    <FormattedMessage
                        id="defaultMessage.status.fully_applied_label"
                        defaultMessage="Fully applied"
                    />
                </div>
            case 'pending':
                return <div className="badge badge-info text-with-icon">
                    <FormattedMessage
                        id="defaultMessage.status.pending_label"
                        defaultMessage="Pending"
                    />
                </div>
        }
        return <div />
    }

    render() {
        return <span className={this.className} style={this.state.style}>
            {this.renderStatus()}
        </span>
    }

}

export default CreditMemoStatusBadge





// WEBPACK FOOTER //
// ./src/invoice/creditmemostatus.component.jsx